import type { ApiResponse, PaginatedResponse, PaginationParams } from '../interfaces/api.interface'
import type { ChatMessage, NewMessagePayload } from '../interfaces/chat.interface'
import { apiSlice } from './api-base.store'

const messageEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMessages: builder.query<
      PaginatedResponse<ChatMessage>,
      { conversationId: string; params?: PaginationParams }
    >({
      query: ({ conversationId, params }) => ({
        url: `/conversations/${conversationId}/messages`,
        params,
      }),
      providesTags: (_result, _error, { conversationId }) => [
        { type: 'Messages', id: conversationId },
      ],
    }),

    sendMessage: builder.mutation<ChatMessage, NewMessagePayload>({
      query: (body) => ({
        url: `/conversations/${body.conversationId}/messages`,
        method: 'POST',
        body,
      }),
      transformResponse: (response: ApiResponse<ChatMessage>) => response.data,
      invalidatesTags: (_result, _error, { conversationId }) => [
        { type: 'Messages', id: conversationId },
        { type: 'Conversation', id: conversationId },
      ],
    }),
  }),
})

export const { useGetMessagesQuery, useSendMessageMutation } = messageEndpoints
